import {
  NOMBRE_APP, RESPONSABLE_DATOS, CONTACTO_PRIVACIDAD, UBICACION_DATOS,
} from './marca';

/**
 * Política de privacidad (/privacidad). Se edita aquí, sin tocar la página.
 *
 * Debe contar lo que la app hace DE VERDAD: al añadir algo que guarde datos
 * nuevos, use otro servicio o mande algo fuera, actualiza esto y la fecha
 * (FECHA_PRIVACIDAD en marca.ts). Lo mismo para la etiqueta de privacidad de
 * App Store Connect, que tiene que cuadrar con este texto.
 *
 * Formato igual que la ayuda: lista de párrafos; los que empiezan por «- » son
 * viñetas. Nada de HTML.
 */
export interface SeccionPrivacidad {
  id: string;
  titulo: string;
  parrafos: string[];
}

export const RESUMEN_PRIVACIDAD = [
  `${NOMBRE_APP} guarda lo que tú apuntas para poder enseñártelo en cualquier dispositivo, y nada más.`,
  '- No hay publicidad ni seguimiento, y no vendemos ni cedemos tus datos.',
  '- Solo los ves tú, salvo los planes de A medias, que ven las personas del plan.',
  '- Puedes borrar tu cuenta y todos tus datos cuando quieras, desde la propia app.',
];

export const PRIVACIDAD: SeccionPrivacidad[] = [
  {
    id: 'responsable',
    titulo: 'Quién es el responsable',
    parrafos: [
      `Responsable del tratamiento: ${RESPONSABLE_DATOS}.`,
      `Para cualquier duda sobre tus datos o para ejercer tus derechos, escribe a ${CONTACTO_PRIVACIDAD}.`,
    ],
  },
  {
    id: 'datos',
    titulo: 'Qué datos guardamos',
    parrafos: [
      'Tu cuenta:',
      '- Tu email y, si lo pones, tu nombre.',
      '- Si entras con Apple o con Google, el identificador que te asignan y el email que comparten. Con «Ocultar mi email» de Apple, guardamos la dirección de reenvío que te da Apple, no la tuya.',
      '- Tu contraseña no la vemos nunca: la gestiona Firebase Authentication (Google) y se guarda cifrada.',
      '- Cuándo creaste la cuenta, cuándo entraste por última vez y qué partes de la app tienes activadas.',
      '- Si te haces myarinn Plus: qué opción tienes, hasta cuándo y dónde la pagaste (App Store, Google Play o la web). Los datos de tu tarjeta no los vemos nunca: los gestiona Apple, Google o Stripe.',
      'Lo que apuntas en cada parte de la app:',
      '- Finanzas: cuentas, movimientos, categorías, presupuestos, movimientos periódicos e inversiones.',
      '- A medias: los planes, sus participantes (pueden ser solo un nombre), gastos, pagos y las fotos de los tickets que subas.',
      '- Préstamos: qué has dejado o te han dejado, a quién y cuándo.',
      '- Taller 3D y Clientes: presupuestos, perfiles de material y máquina, y los datos de tus clientes (contacto, NIF y dirección).',
      'En el iPhone, si activas las notificaciones: un identificador del dispositivo que da Apple para poder mandarte avisos.',
    ],
  },
  {
    id: 'terceros',
    titulo: 'Datos de otras personas que apuntas tú',
    parrafos: [
      'En A medias, Préstamos y Clientes puedes apuntar nombres y otros datos de otras personas. Al hacerlo, tú eres quien decide qué guardar de ellas: apunta solo lo necesario y, si son tus clientes, infórmales como corresponda.',
      'En un plan de A medias, todas las personas que se unen al plan ven sus gastos, pagos, participantes y tickets.',
    ],
  },
  {
    id: 'para-que',
    titulo: 'Para qué los usamos y con qué base legal',
    parrafos: [
      '- Para darte el servicio que pides: guardar tus datos, enseñártelos, hacer los cálculos (saldos, repartos, presupuestos) y compartir los planes con quien tú invites. Base legal: la ejecución del servicio que aceptas al crear la cuenta (art. 6.1.b del RGPD).',
      '- Para mandarte notificaciones de recordatorios, solo si las activas. Base legal: tu consentimiento, que retiras apagándolas en Configuración o en los ajustes del iPhone.',
      '- Para mantener la app segura y que funcione (por ejemplo, comprobar quién puede ver cada dato). Base legal: interés legítimo.',
      'No hacemos perfiles, ni publicidad, ni usamos tus datos para nada más. No usamos herramientas de analítica ni de seguimiento.',
    ],
  },
  {
    id: 'proveedores',
    titulo: 'Quién nos ayuda a darte el servicio',
    parrafos: [
      'Usamos estos proveedores, que tratan los datos solo por cuenta nuestra y para esto:',
      `- Google Firebase (Google Ireland Ltd.): cuentas de usuario y base de datos. Tus datos se guardan en ${UBICACION_DATOS}.`,
      '- Netlify (Netlify, Inc.): aloja la web y ejecuta las tareas del servidor (movimientos periódicos, borrado de cuentas y recordatorios).',
      '- Apple: inicio de sesión con Apple y envío de notificaciones al iPhone.',
      '- Google: inicio de sesión con Google.',
      '- RevenueCat (RevenueCat, Inc.): lleva las suscripciones a myarinn Plus de todas las tiendas. Solo recibe tu identificador de usuario de la app y lo que has comprado.',
      '- Stripe (Stripe Payments Europe, Ltd.): cobra los pagos de Plus hechos en la web. En el iPhone cobra Apple.',
      'Algunos de ellos pueden tratar datos fuera del Espacio Económico Europeo, en Estados Unidos. Lo hacen con las garantías del RGPD: el Marco de Privacidad de Datos UE-EE. UU. o cláusulas contractuales tipo de la Comisión Europea.',
    ],
  },
  {
    id: 'dispositivo',
    titulo: 'Lo que se guarda en tu dispositivo',
    parrafos: [
      'No usamos cookies de publicidad ni de analítica. Para que la app funcione se guarda en tu navegador o en tu iPhone:',
      '- Tu sesión, para no tener que entrar cada vez.',
      '- Una copia de tus datos, para que la app abra rápido y se pueda usar sin conexión. Se borra al cerrar sesión.',
      '- Preferencias de este dispositivo: el modo oscuro, el borrador de la calculadora 3D o si has pospuesto un recordatorio.',
      'Si activas el bloqueo con Face ID o Touch ID, la comprobación la hace tu iPhone: nunca recibimos tu cara ni tu huella, ni ningún dato biométrico.',
    ],
  },
  {
    id: 'conservacion',
    titulo: 'Cuánto tiempo los guardamos',
    parrafos: [
      'Mientras tengas la cuenta. Lo que borras en la app se borra de la base de datos en ese momento.',
      'Si borras tu cuenta (Configuración → Perfil → Eliminar mi cuenta) se borra todo lo tuyo al instante. La excepción son los planes de A medias compartidos: los gastos y pagos se quedan porque son las cuentas del grupo, pero sales del plan y tu nombre queda como un participante sin cuenta.',
      'Los proveedores pueden guardar durante un tiempo limitado registros técnicos (por ejemplo, de accesos al servidor), según sus propias políticas.',
    ],
  },
  {
    id: 'derechos',
    titulo: 'Tus derechos',
    parrafos: [
      'Puedes pedir en cualquier momento acceder a tus datos, corregirlos, borrarlos, llevártelos (portabilidad), oponerte a su tratamiento o limitarlo.',
      '- Muchas cosas las puedes hacer tú desde la app: corregir o borrar lo que apuntaste, exportar tus datos de Finanzas (Configuración → Datos) o borrar la cuenta entera.',
      `- Para lo demás, escribe a ${CONTACTO_PRIVACIDAD}. Te contestaremos en menos de un mes.`,
      'Si crees que no tratamos bien tus datos, puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es).',
    ],
  },
  {
    id: 'seguridad',
    titulo: 'Seguridad',
    parrafos: [
      'Las comunicaciones van cifradas (HTTPS). Cada dato solo lo puede leer su dueño, o los miembros del plan si es de A medias: lo comprueba el propio servidor, no solo la app.',
    ],
  },
  {
    id: 'menores',
    titulo: 'Menores',
    parrafos: [
      `${NOMBRE_APP} no está pensada para menores de 14 años, y no deben crear una cuenta.`,
    ],
  },
  {
    id: 'cambios',
    titulo: 'Cambios en esta política',
    parrafos: [
      'Si cambiamos algo importante, lo avisaremos dentro de la app antes de que se aplique. Arriba tienes siempre la fecha de la última versión.',
    ],
  },
];
